import { render } from "./logout.vue?vue&type=template&id=ae56b56c&scoped=true"
import script from "./logout.vue?vue&type=script&lang=js"
export * from "./logout.vue?vue&type=script&lang=js"

import "./logout.vue?vue&type=style&index=0&id=ae56b56c&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-ae56b56c"

export default script